export default __webpack_public_path__ + "images/0519fc8f048c3125ee6b33f79725caa7.png";